import React from 'react';

import filter from 'lodash/filter';

import calculateDepth from '../calculateDepth';

export const useViewState = ({ initialValues, meta, metricTypes }) => {
  return React.useMemo(() => {
    if (initialValues && meta && metricTypes) {
      const filteredMetricTypes = filter(metricTypes, ({ id }) =>
        meta.metricTypes.includes(id)
      );

      return calculateDepth(initialValues, null, {
        meta,
        metricTypes: filteredMetricTypes,
      });
    }
    return null;
  }, [initialValues, meta, metricTypes]);
};
